module.exports = __webpack_public_path__ + "static/media/resumeBlog3.f583d2a6.png";